import { render, staticRenderFns } from "./relatives-friends-manage.vue?vue&type=template&id=dd596478&scoped=true"
import script from "./relatives-friends-manage.vue?vue&type=script&lang=js"
export * from "./relatives-friends-manage.vue?vue&type=script&lang=js"
import style0 from "./relatives-friends-manage.vue?vue&type=style&index=0&id=dd596478&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd596478",
  null
  
)

export default component.exports